import { OutlinedButton } from '@/components/layouts/Buttons/OutlinedButton/OutlinedButton';
import { RiArrowLeftLine, RiShieldLine } from '@remixicon/react';
import { Card, Flex, Text, Title } from '@tremor/react';
import s from './AccessRestrictedCard.module.scss';
import { useNavigate } from 'react-router-dom';

interface Props {
  message: string;
}

export function AccessRestrictedCard({ message }: Props) {
  const navigate = useNavigate();

  return (
    <Card className={s.card}>
      <Flex flexDirection="col">
        <div className={s.svgWrapper}>
          <RiShieldLine size={32} color="#ba2634" />
        </div>
        <Title className={s.title}>Access Restricted</Title>
        <Text className={s.message}>{message}</Text>
        <OutlinedButton className={s.button} onClick={() => navigate(-1)}>
          <Flex className={s.buttonText}>
            <RiArrowLeftLine />
            Go Back
          </Flex>
        </OutlinedButton>
      </Flex>
    </Card>
  );
}
